import React from 'react';
import classNames from 'classnames';

// @ts-ignore TS(2322): Type 'null' is not assignable to type '"center" | ... Remove this comment to see the full error message
function Text({
  type = 'default',
  theme = 'default',
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '"left" | "right"'.
  align = null,
  children = null,
  className = '',
  ...otherProps
}) {
  const textClassNames = classNames(
    'ws-text',
    `ws-text--type-${type}`,
    `ws-text--theme-${theme}`,
    {
      [`ws-text--align-${align}`]: Boolean(align),
    },
    className
  );

  return (
    <span className={textClassNames} {...otherProps}>
      {children}
    </span>
  );
}

export default Text;
